import {
  Box,
  createStyles,
  //   List,
  //   ListItem,
  //   ListItemText,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Theme,
} from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    paper: {
      width: "100%",
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
    },
    link: {
      color: theme.palette.text.primary,
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline",
      },
    },
  })
);

const Help = (): JSX.Element => {
  const classes = useStyles();
  const links = [
    {
      label: "Esillepanojen suunnittelu",
      url: "https://myymalailmeen-kasikirja.alko.fi/myymala/lisamyyntipaikat/tuotteistuksen-kirjaaminen-esillepanot-sovellukseen.html",
    },
    {
      label: "Tuotteistuksen kirjaaminen",
      url: "https://myymalailmeen-kasikirja.alko.fi/media/esillepanojen-suunnittelu-pikaohje.pdf",
    },
  ];

  return (
    <Box p={{ xs: 0, sm: 2 }}>
      <h1>Ohjeet</h1>
      <Paper className={classes.paper}>
        {/* <List>
        {links.map((link, index) => (
          <ListItem
            key={index}
            component="a"
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <ListItemText primary={link.label} />
          </ListItem>
        ))}
      </List> */}
        <TableContainer>
          <Table>
            <TableBody>
              {links.map((link, index) => (
                <TableRow hover key={index}>
                  <TableCell>
                    <a
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={classes.link}
                    >
                      {link.label}
                    </a>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default Help;
